import { useProductImages } from '../hooks/useProductImages';

type ProductImagesContainerProps = { children: React.ReactNode };

const ProductImagesContainer = ({ children }: ProductImagesContainerProps) => {
	const { blockClass, componentId } = useProductImages();

	const renderClass = () => {
		return (
			blockClass &&
			`vtex-store-components-3-x-productImagesContainer vtex-store-components-3-x-productImagesContainer--${blockClass} vtex-store-components-3-x-productImagesContainer--${blockClass}--carousel vtex-store-components-3-x-content--${blockClass} w-100`
		);
	};

	return (
		<div
			data-selection={componentId}
			className={`productImagesContainer
      productImagesContainer--carousel
      content
      productImagesContainer--${blockClass}
      productImagesContainer--carousel--${blockClass}
      content--${blockClass}
      vtex-store-components-3-x-productImagesContainer vtex-store-components-3-x-productImagesContainer--carousel vtex-store-components-3-x-content ${renderClass()}`}
		>
			{children}
		</div>
	);
};

export default ProductImagesContainer;
